import service from './axios'

export const getLiveProgram = (personId, from, to) =>
  service.get(`/program/live?person_id=${personId}&from=${from}&to=${to}`)

export const getWorkoutDetail = (id) =>
  service.get(`/program/workout?id=${id}`)

export const saveRPE = (id, rpe) =>
  service.putJson(`/summary_card/rpe?id=${id}`, { rpe_manual: rpe })

export const saveEnjoyScore = (id, enjoyScore) =>
  service.putJson(`/summary_card/enjoy_score?id=${id}`, {
    enjoy_score: enjoyScore
  })

export const editProgramWorkout = (personId, payloadArray) =>
  service.post(`/summary_card/${personId}`, payloadArray)
  
export const deleteProgramWorkout = (personId, payload) =>
  service.post(`/summary_card/${personId}`, payload)
